import { Outlet } from "react-router-dom";
import styled from "styled-components";
import { Header } from "../organisms/Header";
import Footer from "../organisms/Footer";


export const MainTemplate: React.FC = () => {
  return (
    <MainWrapper>
      <Header />
      <OutletContainer>
        <Outlet />
      </OutletContainer>
      <Footer />
    </MainWrapper>
  );
};

const MainWrapper = styled.main`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
`;

const OutletContainer = styled.div`
  flex: 1;
  width: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding-top: 80px;
  @media (max-width: 900px) {
    padding-top: 60px;
  }
`;
